<div>
  <h6 v-if="useResource" class="ml-2" style="font-weight: bold;">{{$t(message)}}</h6>
  <h6 v-else class="ml-2" style="font-weight: bold;">{{message}}</h6>
  <b-progress height="2rem" :max="max" :variant="variant" class="mt-3 mb-3">
    <b-progress-bar :value="progressValue" :label="labelDisable ? '' : `${((progressValue / max) * 100).toFixed(0)}%`"></b-progress-bar>
  </b-progress>
</div>